module.exports = __webpack_public_path__ + "img/undraw_reviews_lp8w.c6e15a74.svg";